<template>
  <div>
  <base-dialog title="An error has unfortunately occured!!"  :show="!!error" @close="handleError" > {{ error }}</base-dialog>
  <section>
    <coach-filter @change-filter="changeFilter"></coach-filter>
    
  </section>
  <section>
    <base-card>
      <div class="controls">
        <base-button @click="loadCoaches(true)">Refresh</base-button>
        <base-button link to="register" v-if="!canRegister && !this.isLoading && this.isLoggedIn">Register a Coach</base-button>
        <base-button link to="/auth?redirect=register" v-else-if="!isLoggedIn">Login to register to Coach!</base-button>
      </div>
      <div v-if="isLoading"><base-spinner></base-spinner></div>
      <ul v-else-if="hasCoaches && !isLoading">
        <h3>Coach Counter: {{ filteredCoaches.length }}</h3>
        <coach-item
          v-for="coach in filteredCoaches"
          :key="coach.id"
          :id="coach.id"
          :firstName="coach.firstName"
          :lastName="coach.lastName"
          :areas="coach.areas"
          :rate="coach.hourlyRate"
          >{{ coach.firstName }} {{ coach.lastName }}
        </coach-item>
      </ul>
      <h3 v-else>No coaches found man</h3>
    </base-card>
  </section>
</div>
</template>
<script>
import CoachFilter from '../../components/CoachFilter.vue'
import CoachItem from '../../components/CoachItem.vue';
export default {
  components: {
    CoachItem,
    CoachFilter,
  },
  created(){
    this.loadCoaches()
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isAuthenthicated
    },
    canRegister(){
      return this.$store.getters['coaches/newCoachStatus']
    },
    hasCoaches() {
      return this.$store.getters['coaches/hasCoaches'];
    },
    filteredCoaches(){
        const coaches = this.$store.getters['coaches/coaches'];
        return coaches.filter(coach=>{
            if(this.activeFilters.frontend && coach.areas.includes('frontend')){
                return true
            }
            if(this.activeFilters.career && coach.areas.includes('career')){
                return true
            }
            if(this.activeFilters.backend && coach.areas.includes('backend')){
                return true
            }
            return false
        })
    }
  },
  data() {
    return {
      activeFilters: {
        frontend: true,
        backend: true,
        career: true,
      },
      isLoading: false,
      error: null
    };
  },
  methods: {
    async loadCoaches(refresh = false){
      this.isLoading = true;
      try{
        await this.$store.dispatch('coaches/loadCoaches',{forceRefresh: refresh})
      }catch(error){
        this.error = error.message || 'Something went wrong!!'
      }
      
      this.isLoading = false;
    },
    changeFilter(filter) {
      this.activeFilters = filter;
    },
    handleError(){
      this.error = null;
    }
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.controls {
  display: flex;
  justify-content: space-between;
}
</style>